export const ROOT = '/';
export const TEAMS = '/teams';
export const CONTACTS = '/contacts';
export const SUPPLIES = '/nuetzliches';
export const PRICING = '/pricing';
export const NEWS = '/news';
export const DIRECTION = '/direction';
export const IMPRINT = "/imprint"
export const EVENTS = "/events"
